__turbopack_context__.v({
  "alertCta": "-vjpFq_alertCta",
  "alertFullWidth": "-vjpFq_alertFullWidth",
  "alertTitle": "-vjpFq_alertTitle",
  "blok": "-vjpFq_blok",
  "columns-1": "-vjpFq_columns-1",
  "columns-2": "-vjpFq_columns-2",
  "columns-3": "-vjpFq_columns-3",
  "columns-4": "-vjpFq_columns-4",
  "columns-5": "-vjpFq_columns-5",
  "columns-6": "-vjpFq_columns-6",
  "items": "-vjpFq_items",
  "submitWrapper": "-vjpFq_submitWrapper",
  "submitWrapperSticky": "-vjpFq_submitWrapperSticky",
});
